import useRateAndSellCount from 'hooks/useRateAndSellCount';
import useUrl from '../components/hooks/useUrl';
import Dian from 'icons/store-icon.svg';
// import { formatPrice } from 'libs/utils';
import PlaceholderImage from 'comps/PlaceholderImage';
import { ListData } from 'comps/ShopProListPC';
import { ProductPrice } from '@/comps/FullProductCardItem';

type FullProductListProps = {
  listData: ListData;
};
export default function FullProductList({ listData }: FullProductListProps) {
  const { canView } = useRateAndSellCount();
  const { getPublicUrl } = useUrl();

  function handleOpenDetail(item) {
    window.open(`/product/detail?id=${item.bestSkuSysNo}`);
  }
  // function getSalePrice(data) {
  //   return formatPrice(data.lowestPrice);
  // }

  return (
    <div className="goods-list">
      <div className="gl-hd row clearfix">
        <div className="col gl-info">
          <span>商品信息</span>
        </div>
        <div className="col gl-brand">
          <span>品牌</span>
        </div>
        <div className="col gl-spec">
          <span>规格</span>
        </div>
        {canView && (
          <div className="col gl-sales">
            <span>销量</span>
          </div>
        )}
        <div className="col gl-price">
          <span>单价</span>
        </div>
      </div>
      <div className="gl-bd clearfix">
        {listData.datas?.map((data, index) => (
          <div className="row list-item clearfix" key={index}>
            {data.productTagImageList?.map((item, idx) => (
              <div className="list-img-tag" key={idx}>
                {item.tagName}
              </div>
            ))}
            <div className="col gl-image">
              <div
                className="pointer"
                onClick={() => {
                  handleOpenDetail(data);
                }}
              >
                <PlaceholderImage
                  src={getPublicUrl(data.images?.[0])}
                  height="108px"
                  width="108px"
                />
              </div>
            </div>
            
            {
              !data.hasTradeAgreementFlag && (
                <div className='not-net-tag'>
                  当前区域不可售
                </div>
              )
            }
            <div className="col gl-info-content">
              <div className="list-item-title">
                <div className="mb10">
                  <span className="shop-sign">
                    <Dian />
                    <span className="shop-name">{data.shopName}</span>
                  </span>
                </div>
                {
                  // eslint-disable-next-line @typescript-eslint/no-shadow
                  data.productTagTitleList?.map((item, index) => (
                    <div key={index} className="list-title-tag">
                      {item.tagName}
                    </div>
                  ))
                }
                <span
                  onClick={() => {
                    handleOpenDetail(data);
                  }}
                  title={data.name}
                  className="pointer"
                >
                  {data.name}
                </span>
                {data.upstreamSupplierName && (
                  <span className="upstream-supplier-name-wrap list-upstream-supplier-name-wrap">
                    <span>由 </span>
                    <span className="upstream-supplier-name" title={data.upstreamSupplierName}>
                      {data.upstreamSupplierName}
                    </span>
                    <span>配送</span>
                  </span>
                )}

                <div>
                  <div className="list-service-tag-wrap">
                    {
                      // eslint-disable-next-line @typescript-eslint/no-shadow
                      data.productTagServiceList?.map((item, index) => (
                        <span className="list-service-tag" key={index}>
                          <span className="border-item" />
                          {item.tagName}
                        </span>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="col gl-brand">
              <div className="list-item-brand" title={data.brand}>
                {data.brand}
              </div>
            </div>
            <div className="col gl-spec">
              <div className="list-item-spec">{data.skuCount}种规格</div>
            </div>
            {canView && (
              <div className="col gl-sales">
                <div className="list-item-sales">销量{data.sellCountString}</div>
              </div>
            )}
            <div className="col gl-price">
              {/* <div className="list-item-price">
                {data.shopPriceFlag === 2 && (
                  <>
                    <span className="currency">¥</span>
                    <span className="text">{getSalePrice(data)}</span>
                    <span className="separator">/</span>
                    <span className="unit">{data.unit}</span>
                  </>
                )}
                {data.shopPriceFlag === 1 && (
                  <>
                    <span className="currency">¥</span>
                    <span className="text">待询价</span>
                  </>
                )}
              </div> */}
              <ProductPrice data={data} />
            </div>
            <div className="col gl-detail">
              <div
                onClick={() => {
                  handleOpenDetail(data);
                }}
                className="list-item-detail"
              >
                查看详情
              </div>
            </div>
          </div>
        ))}
      </div>
      <style jsx>{`
        .goods-list {
          margin-top: 20px;
          margin-bottom: 20px;
          font-size: 12px;
        }

        .gl-hd {
          height: 40px;
          color: #999;
          background-color: #f5f5f5;
          line-height: 40px;
        }

        .gl-bd .list-item,
        .gl-hd {
          position: relative;
          width: 100%;
          padding-left: 128px;
        }

        .col,
        .row {
          position: relative;
          display: block;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }

        .row {
          height: auto;
          margin-left: 0;
          margin-right: 0;
          zoom: 1;
        }
        .not-net-tag {
          position: absolute; 
          bottom: 0px;
          left: 0px;
          background: #fff;
          padding: 3px 3px;
          color: red;
        }
        .gl-bd .list-item .gl-info,
        .gl-hd .gl-info {
          width: 33%;
        }

        .gl-bd .list-item .gl-amount,
        .gl-bd .list-item .gl-brand,
        .gl-bd .list-item .gl-info,
        .gl-bd .list-item .gl-price,
        .gl-bd .list-item .gl-sales,
        .gl-bd .list-item .gl-spec,
        .gl-hd .gl-amount,
        .gl-hd .gl-brand,
        .gl-hd .gl-info,
        .gl-hd .gl-price,
        .gl-hd .gl-sales,
        .gl-hd .gl-spec {
          padding-right: 20px;
        }

        .col {
          float: left;
          min-height: 1px;
          padding-left: 0;
          padding-right: 0;
        }

        .gl-bd .list-item .gl-brand,
        .gl-hd .gl-brand {
          width: 10%;
        }

        .gl-bd .list-item .gl-sales,
        .gl-bd .list-item .gl-spec,
        .gl-hd .gl-sales,
        .gl-hd .gl-spec {
          width: 11%;
        }

        .gl-bd .list-item .gl-price,
        .gl-hd .gl-price {
          width: 15%;
        }

        .gl-bd {
          width: 100%;
          height: auto;
        }

        .list-item {
          min-height: 128px;
          padding-top: 10px;
          padding-bottom: 10px;
          border-bottom: 1px solid #e8e8e8;
        }

        .list-img-tag {
          position: absolute;
          top: 15px;
          left: 5px;
          background-color: rgba(245, 34, 45, 0.9);
          padding: 4px 6px 3px;
          font-size: 12px;
          color: #fff;
          line-height: 1;
          display: inline-block;
          z-index: 10;
        }

        .gl-image {
          width: 108px;
          height: 108px;
          position: absolute;
          top: 10px;
          left: 0;
          overflow: hidden;
        }

        .gl-image img {
          width: 108px;
          height: 108px;
        }

        .gl-info-content {
          width: 33%;
          display: table;
          min-height: 108px;
        }

        .list-item-title {
          height: auto;
          overflow: hidden;
          display: table-cell;
          vertical-align: middle;
        }

        .mb10 {
          margin-bottom: 10px;
        }

        .shop-sign {
          line-height: 12px;
          font-size: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          display: flex;
          align-items: center;
        }

        .shop-name {
          color: #999;
          width: calc(100% - 20px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          vertical-align: middle;
          line-height: 12px;
          font-size: 12px;
          margin-left: 4px;
        }

        .list-title-tag {
          padding: 4px;
          background: var(--primaryColor);
          border-radius: 1px;
          font-size: 12px;
          color: #fff;
          line-height: 1;
          display: inline-block;
          margin-right: 7px;
        }

        .list-item-title a {
          display: inline-block;
          vertical-align: top;
          color: #333;
          font-size: 14px;
          font-weight: 400;
          transition: color 0.2s;
          cursor: pointer;
        }

        .list-service-tag-wrap {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 23px;
          line-height: 23px;
          display: inline-block;
          max-width: 340px;
          margin-top: 8px;
          position: relative;
        }

        .list-service-tag {
          padding: 4px;
          border-radius: 1px;
          font-size: 12px;
          color: #f5222d;
          line-height: 1;
          margin-right: 2px;
          position: relative;
        }
        .border-item {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          border: 1px solid #f5222d;
        }

        .list-service-tag:last-child .border-item {
          border-right: none;
          margin-right: 0;
        }

        .list-service-tag-wrap:after {
          content: "";
          width: 1px;
          height: 23px;
          background-color: #f5222d;
          position: absolute;
          right: 1px;
          top: 0;
        }

        .gl-bd .col.gl-brand,
        .gl-bd .col.gl-price,
        .gl-bd .col.gl-sales,
        .gl-bd .col.gl-spec {
          position: relative;
          min-height: 108px;
        }

        .col.gl-brand .list-item-brand,
        .col.gl-brand .list-item-price,
        .col.gl-brand .list-item-sales,
        .col.gl-brand .list-item-spec,
        .col.gl-price .list-item-brand,
        .col.gl-price .list-item-price,
        .col.gl-price .list-item-sales,
        .col.gl-price .list-item-spec,
        .col.gl-sales .list-item-brand,
        .col.gl-sales .list-item-price,
        .col.gl-sales .list-item-sales,
        .col.gl-sales .list-item-spec,
        .col.gl-spec .list-item-brand,
        .col.gl-spec .list-item-price,
        .col.gl-spec .list-item-sales,
        .col.gl-spec .list-item-spec {
          padding-right: 20px;
          margin-top: 0;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          word-break: break-all;
        }

        .list-item-brand,
        .list-item-sales,
        .list-item-spec {
          color: #333;
        }

        .list-item-price {
          font-size: 14px;
          color: #fa5400;
          word-break: break-all;
        }

        .list-item-price span {
          margin-right: 2px;
        }

        .gl-detail {
          position: absolute;
          right: 35px;
          top: 54px;
        }

        .list-item-detail {
          background-color: #fff;
          cursor: pointer;
          width: 100px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #e8e8e8;
          border-radius: 2px;
          font-size: 12px;
          color: #666;
          display: block;
        }

        .pointer {
          cursor: pointer;
        }

        .upstream-supplier-name-wrap {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #666;
          height: 17px;
        }

        .upstream-supplier-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #999;
          max-width: 230px;
        }
      `}</style>
    </div>
  );
}
